<template>

<div>

    <div v-if='!offerSent'>
        <h3 class="fieldset-title">Заяви своето участие</h3>
        <div class="row">
            <div class="col-12">
                <p>
                    За да участваш с предложение за идеен проект, 
                    необходимо е да се запишеш за участие, 
                    натискайки бутона по-долу. Това ти гарантира, че
                    ще получиш известие при настъпили събития в проекта.
                </p>
                <p>
                    <strong>В таймера се визуализира времето, 
                    което имаш за да помислиш и прецениш дали искаш да участваш.
                    След неговото изтичане, няма да можеш да се включиш в конкурса.</strong>
                </p>
                <p>
                    <strong>Записвайки се за участие, ти гарантираш, че ще
                    предоставиш идеен проект в определения срок. Неспазване
                    на ангажимента води до редуциране на рейтинга ти.</strong>
                </p>

                <h6 class="text-center"> Крайният срок за предаване на проекта е: </h6>
                <h3 class="text-center"> {{ bgDate( $parent.projectPhase.end_date ) }} </h3>

                <phase-terms :desc='$parent.$parent.phase.desc'></phase-terms>

            </div>
        </div>
        <div class="row">
            
            <div v-if='!$parent.finished' class="col-12 text-center mt-2">
                <button @click='sendOffer' class="btn btn-primary btn-lg">Участвам</button>
            </div>
            
            <div v-if='$parent.finished' class="col-12 text-center mt-2">
                <div class="alert alert-warning">
                    Времето за подаване на заявки за участие е изтекло.           
                </div>
            </div>

        </div>
    </div>

    <div v-if='offerSent'>

        <div class="alert alert-info mb-3">
            Успешно заявихте участие в конкурса!
        </div>

    </div>
 

</div>

</template>

<script>
    export default {

        mounted() {

        },

        created() {
           
        },

        data() {
            return {
                isReady : false,
                acceptTerms : false,

                model : {
                    title : '',
                    desc  : '',
                },

                offerSent : false
            }
        },

        methods : {

            sendOffer() {
                var me = this;

                if( !this.acceptTerms ) {
                    $.notify('Моля приемете изискванията за да кандидатствате','warning');

                    return;
                }
                

                var data = { 
                    o : this.model, 
                    pp : this.$parent.$parent.projectPhase.id 
                };

                //Apply for work
                me.ajax.call('phs:suo', data, (r) => {
                    
                    if( r.status == 'success' ) {
                        me.offerSent = true;

                        me.$parent.offer = Object.assign( {}, r.data, { finished : 0 } );

                        $.notify('Успешно заявихте участието си в този етап на проекта!','success');
                    } 

                })
            }

        }

    }
</script>
